export default {
  isActive (state) {
    return state.isActive;
  },
};
